import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  getProjectApprovals,
  changeApprovalStatus,
} from "../../../api/projectApprovalApi";
import Estimate from "../../ProjectsV2/ProjectFinance/Estimate/Estimate";
import Preloader from "../../Preloader/Preloader";
import "./ProjectApprovalDetail.css";

function ProjectApprovalDetail() {
  const { projectId, approvalId } = useParams();
  const navigate = useNavigate();
  const [approval, setApproval] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(null);

  const fetchApproval = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const approvals = await getProjectApprovals(parseInt(projectId));
      const foundApproval = approvals.find(
        (a) => a.id === parseInt(approvalId)
      );

      if (!foundApproval) {
        setError("Согласование не найдено");
        return;
      }

      setApproval(foundApproval);
    } catch (err) {
      setError("Ошибка при загрузке данных согласования");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }, [projectId, approvalId]);

  useEffect(() => {
    fetchApproval();
  }, [fetchApproval]);

  const handleApprove = async () => {
    if (!approval || !projectId || !approvalId) return;

    try {
      setIsProcessing(true);
      await changeApprovalStatus(
        parseInt(projectId),
        parseInt(approvalId),
        "согласован"
      );
      // После успешного согласования возвращаемся к списку
      navigate("/approvals/project-approval");
    } catch (err) {
      setError("Ошибка при согласовании проекта");
      console.error(err);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleReject = async () => {
    if (!approval || !projectId || !approvalId) return;

    try {
      setIsProcessing(true);
      await changeApprovalStatus(
        parseInt(projectId),
        parseInt(approvalId),
        "не согласован"
      );
      // После успешного отклонения возвращаемся к списку
      navigate("/approvals/project-approval");
    } catch (err) {
      setError("Ошибка при отклонении проекта");
      console.error(err);
    } finally {
      setIsProcessing(false);
    }
  };

  if (isLoading) {
    return <Preloader />;
  }

  if (error && !approval) {
    return (
      <div className="project-approval-detail">
        <div className="project-approval-detail__error">{error}</div>
        <button
          className="project-approval-detail__back-button"
          onClick={() => navigate("/approvals/project-approval")}
        >
          Вернуться к списку
        </button>
      </div>
    );
  }

  return (
    <div className="project-approval-detail">
      {/* Статус "На рассмотрении" сверху */}
      <div className="project-approval-detail__status-header">
        <button
          className="project-approval-detail__back-button-header"
          onClick={() => navigate("/approvals/project-approval")}
        >
          <span className="project-approval-detail__back-arrow">←</span>
          <span className="project-approval-detail__back-text">
            Назад к списку проектов
          </span>
        </button>
        <div className="project-approval-detail__status-content">
          <span className="project-approval-detail__status-icon">📄</span>
          <span className="project-approval-detail__status-text">
            На рассмотрении
          </span>
        </div>
      </div>

      {/* Компонент сметы */}
      <div className="project-approval-detail__estimate-container">
        <Estimate projectId={projectId} isReadOnly={true} />
      </div>

      {/* Кнопки согласования/отклонения */}
      <div className="project-approval-detail__actions">
        <button
          className="project-approval-detail__button project-approval-detail__button--reject"
          onClick={handleReject}
          disabled={isProcessing}
        >
          Отклонить
        </button>
        <button
          className="project-approval-detail__button project-approval-detail__button--approve"
          onClick={handleApprove}
          disabled={isProcessing}
        >
          Согласовать
        </button>
      </div>

      {error && (
        <div className="project-approval-detail__error-message">{error}</div>
      )}
    </div>
  );
}

export default ProjectApprovalDetail;
